import React, {useEffect, useState} from "react";
import {GetObjectCommand, S3Client} from "@aws-sdk/client-s3";
import axios from "axios";
import {APIURL} from "../../variables/constants";
import {GrDislike, GrLike} from "react-icons/gr";
import "assets/css/App.css";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {useSelector} from "react-redux";
import {updateFeedback} from "../../actions";
import {useMsal} from "@azure/msal-react";

const S3_BUCKET = "gcny-ai-logs";
const REGION = "us-east-1";


const ChatDetailsComponent = ({id}) => {
    const [s3Data, setS3Data] = useState([]);
    const [metaData, setMetaData] = useState([]);
    const [rateValue, setRateValue] = useState(0);
    let AllChats = useSelector(state => state.AllChats)
    const {accounts} = useMsal();
    const username = (accounts[0]?.username || accounts[0]?.idTokenClaims?.preferred_username || "Unknown User");



    let config = {
        region: REGION, credentials: {
            accessKeyId: 'AKIA2KWPEY5MGVZYACJJ', secretAccessKey: 'cc2R7gQPpBHnCAiIH+i7XVOUSd19sjGcYPyxZmG5',
        }
    }

    const options = {
        title: 'Your Changes has been saved successfully',
        message: '',
        buttons: [
            {
                label: 'Okay',
                onClick: () => {
                }
            }
        ],
        closeOnEscape: true,
        closeOnClickOutside: true,
        keyCodeForClose: [8, 32],
        willUnmount: () => {
        },
        afterClose: () => {
        },
        onClickOutside: () => {
        },
        onKeypress: () => {
        },
        onKeypressEscape: () => {
        },
        overlayClassName: "overlay-custom-class-name"
    };


    useEffect(() => {
        const fetchData = async () => {
            let rawData = null;

            try {
                const client = new S3Client(config);
                const params = { Bucket: S3_BUCKET, Key: `${id}` };
                const command = new GetObjectCommand(params);
                const response = await client.send(command);
                const bodyText = await response.Body.transformToString();
                rawData = JSON.parse(bodyText);
            } catch (err) {
                try {
                    const fallbackRes = await axios.get(`https://agent.gabrielny.com/chat/${id}`);
                    rawData = fallbackRes.data;
                } catch (fallbackErr) {
                    console.error("S3 and fallback fetch failed", fallbackErr);
                    return;
                }
            }

            let normalizedMessages = [];
            if (rawData.conversation) {
                normalizedMessages = rawData.conversation;
            } else if (
                rawData.chathistory &&
                rawData.chathistory.llm_context &&
                Array.isArray(rawData.chathistory.llm_context.messages)
            ) {
                normalizedMessages = rawData.chathistory.llm_context.messages.map(msg => {
                    const role = msg.source === "user" ? "user" : "assistant";
                    const content = typeof msg.content === "string" ? msg.content : JSON.stringify(msg.content);
                    return { role, content };
                });
            }

            setS3Data(normalizedMessages);

            try {
                const metadataRes = await axios.get(`${APIURL}?query=getDetails&id=${id}`);
                if (metadataRes.data) setMetaData(metadataRes.data);
            } catch (metaErr) {
                console.error("Metadata fetch failed:", metaErr);
            }
        };

        fetchData();
    }, [id]);;



    const PrettyJsonOutput = ({jsonString}) => {
        let jsonObject = {};
        try {

            jsonObject = JSON.parse(jsonString);

            const renderJson = (obj) => {
                return Object.entries(obj).map(([key, value]) => {
                    if (typeof value === 'object' && value !== null) {
                        return (
                            <div key={key}>
                                <strong>{key}</strong>: {renderJson(value)}
                            </div>
                        );
                    } else if (key === 'QuestionToUser') {
                        return (
                            <div key={key}>
                                <strong>{key}</strong>: {JSON.stringify(value)}
                            </div>
                        );
                    } else {

                        return (
                            <div key={key}>
                                {key}: {JSON.stringify(value)}
                            </div>
                        );
                    }
                });
            };

            return <div>{renderJson(jsonObject)}</div>;

        } catch (error) {
            jsonObject = jsonString;

            return <div>{jsonObject}</div>;
        }


    };

    const submitForm = (e) => {
        e.preventDefault();
        const {moderatorfeedback, moderatorRate, technicalFeedback} = e.target.elements


        axios.post(`${APIURL}`, {
            id: id,
            query: 'updateRecord',
            data: {
                "moderatorfeedback": moderatorfeedback.value,
                "technicalFeedback": technicalFeedback.value,
                "moderatorRate": moderatorRate.value,
                "moderatorName": username
            }
        })
            .then((response) => {
                confirmAlert(options);

                updateFeedback(id, moderatorfeedback.value, technicalFeedback.value);

            })
            .catch((error) => {
                console.log(error);
            })

    };

    const updateRecord = (e) => {
        e.preventDefault();

        axios.post(`${APIURL}`, {
            id: id,
            query: 'updateRecord',
            data: {
                [e.target.name]: e.target.value,
                "moderatorName": username
            }
        })
            .then((response) => {

            })
            .catch((error) => {
                console.log(error);
            })

    }

    const RenderMessage = ({jsonString}) => {
        let output = "";

        try {
            const messageData = JSON.parse(jsonString);

            const textResponse = messageData.TextResponse;
            const options = messageData.hasOwnProperty("Options") ? messageData.Options : "-";

            output = (
                <div>
                    <div dangerouslySetInnerHTML={{__html: textResponse}}></div>
                    <div>Options Provided: {options.join(', ')}</div>
                </div>
            );
        } catch (error) {
            output = <PrettyJsonOutput jsonString={jsonString}/>;
        }

        return (
            <div>
                {output}
            </div>
        );
    };

    return (
        <div className="grid grid-cols-12 gap-4">
            <div className="col-span-8">
                <div className="bg-transparent chatRenderer h-full overflow-auto">
                    {s3Data.length > 0 ? (
                        s3Data.map((message, index) => (
                            message.role !== "function" && !message.content.includes("### BOT") && (
                                <div key={index} className="mb-4 bg-white p-4 rounded-md">
                                    <strong
                                        className={`block ${message.role === 'user' ? 'text-blue-500' : 'text-green-500'}`}>
                                        {message.role === 'user' ? 'User' : 'Assistant'}:
                                    </strong>
                                    <p className="mt-1 text-gray-700">
                                        {message.role === 'user' ? message.content : <RenderMessage jsonString={message.content} />}
                                    </p>
                                </div>
                            )
                        ))
                    ) : (
                        <div className={"text-center"}>
                            <p>No Chat history available</p>
                        </div>
                    )}
                </div>
            </div>

            <div className="col-span-4 grid grid-cols-1 gap-2">
                <div className={"flex flex-col gap-3"}>
                    <div className="p-4 bg-white shadow-sm gap-1 grid grid-cols-1 rounded-md">
                        <p className={"mb-1 font-semibold"}>Chat Details: </p>

                        <p>User: {id.split('_')[1]}</p>
                        <p>Date & Time: {metaData.length > 0 ? metaData[0].Date : "-"}</p>
                        <p>Platform: {metaData.length > 0 ? metaData[0].platform : "-"}</p>
                        <p>Critical Issue:

                            {metaData.length > 0 ?
                                <select name={"CriticalIssues"} onChange={(e) => updateRecord(e)}
                                        className={"p-1 ml-2 rounded-md"}>
                                    <option selected={metaData[0].CriticalIssues.toLowerCase() == "yes"}
                                            value={"Yes"}>Yes
                                    </option>
                                    <option selected={metaData[0].CriticalIssues.toLowerCase() == "no"}
                                            value={"No"}>No
                                    </option>



                                </select> : "-"}
                        </p>

                        <p>NB of interactions: {metaData.length > 0 ? metaData[0].interactions : "-"}</p>

                        <p>Category:

                            {metaData.length > 0 ?
                                <select name={"Category"} onChange={(e) => updateRecord(e)}
                                        className={"p-1 ml-2 rounded-md"}>
                                    <option selected={metaData[0].Category.toLowerCase() == "start new order"}
                                            value={"Start New Order"}>Start New Order
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "knowledge search"}
                                            value={"Knowledge Search"}>Knowledge Search
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "agent"}
                                            value={"Agent"}>Agent
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "item info"}
                                            value={"Item Info"}>Item Info
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "b2b issue"}
                                            value={"B2B Issue"}>B2B Issue
                                    </option>
                                    <option
                                        selected={metaData[0].Category.toLowerCase() == "sod (special order design)"}
                                        value={"SOD (Special Order Design)"}>SOD (Special Order Design)
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "order details"}
                                            value={"Order Details"}>Order Details
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "order status"}
                                            value={"Order Status"}>Order Status
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "configure items"}
                                            value={"Configure Items"}>Configure Item
                                    </option>
                                    <option selected={metaData[0].Category.toLowerCase() == "Return"}
                                            value={"Return"}>Returns
                                    </option>
                                </select> : "-"
                            }
                        </p>

                        <p>Correct Info Provided:

                            {metaData.length > 0 ? <select name={"CorrectInfo"} onChange={(e) => updateRecord(e)}
                                                           className={"p-1 ml-2 rounded-md"}>
                                <option selected={metaData[0].CorrectInfo.toLowerCase() === "yes"} value="Yes">Yes
                                </option>
                                <option selected={metaData[0].CorrectInfo.toLowerCase() === "no"} value="No">No</option>
                            </select> : "-"}
                        </p>

                        <p>Bot Solved the issue:

                            {metaData.length > 0 ? <select name={"BotSolved"} onChange={(e) => updateRecord(e)}
                                                           className={"p-1 ml-2 rounded-md"}>
                                <option selected={metaData[0].BotSolved.toLowerCase() === "true"} value="True">Yes
                                </option>
                                <option selected={metaData[0].BotSolved.toLowerCase() === "false"} value="False">No
                                </option>
                                <option selected={metaData[0].BotSolved.toLowerCase() === "null"}
                                        value="NULL">undecided
                                </option>
                            </select> : "-"}
                        </p>


                        <p>Agent Requested Directly:

                            {metaData.length > 0 ?
                                <select name={"AgentRequestedDirectly"} onChange={(e) => updateRecord(e)}
                                        className={"p-1 ml-2 rounded-md"}>
                                    <option selected={metaData[0].AgentRequestedDirectly.toLowerCase() == "yes"}
                                            value={"Yes"}>Yes
                                    </option>
                                    <option selected={metaData[0].AgentRequestedDirectly.toLowerCase() == "no"}
                                            value={"No"}>No
                                    </option>



                                </select> : "-"}

                        </p>
                        <p>Transfer to
                            Agent:
                            &nbsp;
                            {metaData.length > 0 && metaData[0].transfer_to_agent.charAt(0).toUpperCase() + String(metaData[0].transfer_to_agent).slice(1).toLowerCase()}
                            {}
                            {}
                            {}
                            {}
                            {}
                            {}
                            {}
                        </p>
                        <p>Feeling: {metaData.length > 0 ?
                            <select name={"Feeling"} onChange={(e) => updateRecord(e)}
                                    className={"p-1 ml-2 rounded-md"}>
                                <option selected={metaData[0].Feeling.toLowerCase() == "neutral"}
                                        value={"neutral"}>Neutral
                                </option>
                                <option selected={metaData[0].Feeling.toLowerCase() == "happy"}
                                        value={"happy"}>Happy
                                </option>

                                <option selected={metaData[0].Feeling.toLowerCase() == "negative"}
                                        value={"negative"}>Negative
                                </option>
                            </select>


                            : "-"}
                        </p>


                        <p>Rating: {metaData.length > 0 ? metaData[0].rating ? metaData[0].rating : "N/A" : "-"}</p>


                        <a target={"_blank"}
                           href={`https://gcny-ai-logs.s3.amazonaws.com/ailogs${id.replace(".json", ".html")}`}
                           className={"mt-2 text-sm text-cyan-700 underline"}>Check Logs</a>
                    </div>


                    <div className="p-4 bg-white shadow-sm rounded-md">
                        <p className={"mb-1 font-semibold"}>Summary: </p>
                        <p>{metaData.length > 0 ? metaData[0].Issue : "-"}</p>
                    </div>


                    <form onSubmit={(e) => submitForm(e)} className="p-4 bg-white shadow-sm rounded-md">


                        <p className={"mb-1 font-semibold"}>Technical Feedback: </p>
                        <div>
                            <textarea name={"technicalFeedback"}
                                      defaultValue={metaData.length > 0 ? metaData[0].technicalFeedback : ""}
                                      placeholder={"Enter your technical feedback here.."}
                                      className={"w-full border p-2 rounded-lg h-56"}/>
                        </div>
                        <br/>
                        <p className={"mb-1 font-semibold"}>Customer Support Feedback: </p>
                        <div>
                            <textarea name={"moderatorfeedback"}
                                      defaultValue={metaData.length > 0 ? metaData[0].moderatorfeedback : ""}
                                      placeholder={"Enter your customer support expertise here..."}
                                      className={"w-full border p-2 rounded-lg h-56"}/>
                        </div>


                        <div className={"flex flex-row-reverse mt-4 gap-4"}>
                            <span><button type={"submit"}
                                          className={"bg-lightPrimary p-2 pl-4 pr-4 rounded-md"}>Save</button></span>

                            <input type={"hidden"} name={"moderatorRate"} value={rateValue}/>
                            <span title={"Thumbs down"}><GrDislike onClick={() => setRateValue(-1)}
                                                                   color={rateValue == -1 ? "red" : "black"}
                                                                   className="h-6 w-6 cursor-pointer"/></span>
                            <span title={"Thumbs up"}><GrLike onClick={() => setRateValue(1)}
                                                              color={rateValue == 1 ? "green" : "black"}
                                                              className="h-6 w-6 cursor-pointer"/></span>
                        </div>

                        <div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChatDetailsComponent;
